import React from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import ViewTeamsTable from '../ui/ViewTeamsTable';

const ViewTeams = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="flex-grow">
                <ViewTeamsTable />                          
            </div>
            <CustomFooter />
        </div>
    );
};

export default ViewTeams;